import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';

export default function RelatedLoadsTab({ endpoint }) {
  const [loads, setLoads] = useState(null);

  useEffect(() => {
    setLoads(null);
    api(endpoint).then(setLoads).catch(() => setLoads([]));
  }, [endpoint]);

  if (loads === null) return <div className="empty">Loading...</div>;
  if (loads.length === 0) return <div className="empty">No loads found for this record yet.</div>;

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString() : '';

  return (
    <table>
      <thead>
        <tr><th>Load #</th><th>Commodity</th><th>Status</th><th>Pickup</th><th>Delivery</th><th>Rate</th></tr>
      </thead>
      <tbody>
        {loads.map(l => (
          <tr key={l.id}>
            <td>{l.load_number}</td>
            <td>{l.commodity || '—'}</td>
            <td>{l.status}</td>
            <td>{l.pickup_location || '—'}{l.pickup_date ? ` — ${fmtDate(l.pickup_date)}` : ''}</td>
            <td>{l.delivery_location || '—'}{l.delivery_date ? ` — ${fmtDate(l.delivery_date)}` : ''}</td>
            <td>{l.rate ? `$${Number(l.rate).toFixed(2)}` : '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
